/**
 * enum for all route names
 */
const Routes = {
  LANDING: 'Landing',
  LOGIN: 'Login',
  CHECK_IN: 'CheckIn',
  THANKYOU: 'ThankYou',
  SURVEY: 'Survey',
  ABOUT: 'About',
  SIMPLE_ABOUT: 'SimpleAbout',
  WEBVIEW: 'Webview',
  WALKTHROUGH: 'Walkthrough',
  TERMS_CONDITIONS: 'Terms',
  PRIVACY_POLICY: 'Privacy',
  BLE: 'BLE',
  TIME: 'Time',
  LOAD_NEW_VERSION: 'LoadNewVersion',
  MAINTENANCE_MODE: 'MaintenanceMode',
  SKETCH_CANVAS: 'SketchCanvas',
  CUSTOM_LANDING_PFLEGEQM: 'PflegeQM',
};

/**
 * enum for all stacks
 */
const Stacks = {
  SIGNED_IN: 'SignedIn',
  SIGNED_OUT: 'SignedOut',
  FORCE_NEW_VERSION: 'ForceNewVersion',
};

export { Routes, Stacks };
